module.exports = __webpack_public_path__ + "img/icons B_34.b02aea31.svg";